module.exports = __webpack_public_path__ + "media/icons/chevron-right-6e2db3d1.png";